/**
 * @generated SignedSource<<0061e96cb5a77ba51488c7c16ded2c8a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ClientClass = "CUSTOMER" | "MEMBER";
import { FragmentRefs } from "relay-runtime";
export type useInitializeBookingWizardSession$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly clientClass: ClientClass | null | undefined;
      readonly firstName?: string | null | undefined;
      readonly id?: string;
      readonly lastName?: string | null | undefined;
      readonly membershipType: {
        readonly id: string;
      } | null | undefined;
      readonly preferredTransportationType?: {
        readonly enabled: boolean;
        readonly id: string;
      } | null | undefined;
      readonly profileImage?: {
        readonly publicId: string;
      } | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"useGetRequiredWizardSteps">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"useBookingPaymentCards_session">;
  readonly " $fragmentType": "useInitializeBookingWizardSession";
};
export type useInitializeBookingWizardSession$key = {
  readonly " $data"?: useInitializeBookingWizardSession$data;
  readonly " $fragmentSpreads": FragmentRefs<"useInitializeBookingWizardSession">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Image",
    "kind": "LinkedField",
    "name": "profileImage",
    "plural": false,
    "selections": [
      {
        "alias": "publicId",
        "args": null,
        "kind": "ScalarField",
        "name": "renderingKey",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "slotId",
        "variableName": "slotId"
      }
    ],
    "concreteType": "TransportationType",
    "kind": "LinkedField",
    "name": "preferredTransportationType",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enabled",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "currentDate"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "forSlotId"
    },
    {
      "kind": "RootArgument",
      "name": "slotId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useInitializeBookingWizardSession",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "bookingDate",
          "variableName": "currentDate"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useBookingPaymentCards_session"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "forSlotId",
              "variableName": "forSlotId"
            }
          ],
          "kind": "FragmentSpread",
          "name": "useGetRequiredWizardSteps"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "clientClass",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "membershipType",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "Member",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "Customer",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};
})();

(node as any).hash = "9884dc2be0b6811a746b4c25d9e7fbce";

export default node;
